<template>
  <TemplateView>
    <TemplatePage :loading="loading">
      <div class="container">
        <StatisticProjectReportCheckBlank
          v-if="workClientProjectsWorkTypeAll_project && workClientShow"
          :data="workClientProjectsPeriodReportShow"
          :selected-dates="selectedDates"
          :client="workClientShow"
          :work="workClientProjectsWorkTypeAll_project"
          :extra-works-price="workClientProjectShow.extra_works_price || 0"
        />
      </div>
    </TemplatePage>
  </TemplateView>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import TemplateView from '../../../components/templates/TemplateView'
import TemplatePage from '../../../components/templates/TemplatePage'
import StatisticProjectReportCheckBlank from '../../../components/timeControl/reports/StatisticProjectReportCheckBlank'

export default {
  name: 'timeControlShowReportsCheck',
  components: {
    StatisticProjectReportCheckBlank,
    TemplatePage,
    TemplateView,
  },
  data: () => ({
    loading: true,
  }),
  computed: {
    ...mapGetters('workClientProjectsPeriodReport', ['workClientProjectsPeriodReportShow']),
    ...mapGetters('workClient', ['workClientShow']),
    ...mapGetters('workClientProject', ['workClientProjectShow']),
    ...mapGetters('workClientProjectsWorkType', ['workClientProjectsWorkTypeAll_project']),
    selectedDates() {
      let obj = {}
      obj.dates = this.$getDates(
        new Date(this.workClientProjectsPeriodReportShow.start_date),
        new Date(this.workClientProjectsPeriodReportShow.end_date),
      )
      obj.weeks = []
      for (let date of obj.dates) {
        if (!obj.weeks.find((i) => i === date.getWeek())) obj.weeks.push(date.getWeek())
      }
      return obj
    },
  },
  created() {
    this.onFirstLoad()
  },
  methods: {
    ...mapActions('workClientPerson', ['onWorkClientPersonShow']),
    ...mapActions('workClientProject', ['onWorkClientProjectShow']),
    ...mapActions('workClientProjectsPeriodReport', ['onWorkClientProjectsPeriodReportShow']),
    ...mapActions('workClientProjectsWorkType', ['onWorkClientProjectsWorkTypeAll_project']),
    ...mapActions('workClient', ['onWorkClientShow']),
    async onFirstLoad() {
      await this.onWorkClientProjectsPeriodReportShow(this.$route.params.report_id)
        .then(() => {
          this.onWorkClientProjectsWorkTypeAll_project(this.$route.params.id)
          this.onWorkClientProjectShow(this.$route.params.id)
          this.onWorkClientShow(this.workClientProjectsPeriodReportShow.data.project.client.id)
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },
  },
}
</script>
